var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-scroll"},[_c('div',{ref:"scrollContainer",staticClass:"pdf-frame"},[(_vm.pdfSource && _vm.pdfWidth)?_c('vue-pdf-embed',{attrs:{"source":_vm.pdfSource,"width":_vm.pdfWidth},on:{"loaded":_vm.tryViewContract}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }